<template>
  <v-btn
    @click="onClickDownloadDanfe"
    :loading="loading"
    class="normal-btn-text elevation-0 rounded-tag-small"
    small
  >
    DANFE
  </v-btn>
</template>

<script>
import NotasFiscaisService from '@/modules/notas-fiscais/notas-fiscais-service';

export default {
  props: {
    notaFiscal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    onClickDownloadDanfe() {
      this.loading = true;
      NotasFiscaisService.getDanfe(this.notaFiscal.id)
        .then(({ data }) => {
          const linkSource = `data:application/pdf;base64,${data}`;
          const downloadLink = document.createElement('a');
          const fileName = `danfe-${this.notaFiscal.chaveAcesso}.pdf`;

          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>;
